import React from "react";

import * as typography from "@client/shared/typography";

import {ManagerLayout} from "@client/site/ManagerLayout";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.CreateMealPlan) => {
    const title = "Create meal plan";
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleSubmit = () => {
        setIsSubmitting(true);
    };
    const action = isSubmitting === false ? "Create" : "Processing...";

    return (
        <ManagerLayout narrow title={title} currentClientManagerId={null}>
            <form
                className="flex flex-col space-y-[15px]"
                onSubmit={handleSubmit}
                noValidate
                method="POST"
                action=""
            >
                <forms.CSRFToken />
                <ClientNavigation>
                    <typography.Header>{title}</typography.Header>
                </ClientNavigation>
                <div className="manager-form max-w-[400px] space-y-[15px]">
                    <forms.Fields form={props.form} />
                </div>
                <typography.P>
                    After creating your meal plan, you’ll be able to add and remove
                    meals and entries.
                </typography.P>
                <typography.P>
                    You can then use the planner to assign this meal plan to clients.
                </typography.P>
                <typography.Button submit disabled={isSubmitting}>
                    {action}
                </typography.Button>
            </form>
        </ManagerLayout>
    );
};
